import Reveal from "../Reveal";
import JourneyPath from "../JourneyPath";
import { DESTINATIONS } from "../../data/content";

const NUMERALS = ["I", "II", "III"];

export default function Destinations() {
    return (
        <section id="destinations" className="section-pad bg-navy text-cream" data-testid="destinations-section">
            <div className="container-luxe">
                <Reveal className="mb-14 max-w-2xl">
                    <p className="eyebrow mb-5">Where We Take You</p>
                    <h2 className="font-serif text-3xl sm:text-4xl leading-snug">
                        Destinations, <span className="italic text-gold">chosen slowly</span>
                    </h2>
                    <p className="mt-5 text-cream/70 font-light leading-relaxed">
                        Twenty-four countries across three regions — each one known to us personally, street by street.
                    </p>
                </Reveal>

                <div className="grid gap-12 lg:grid-cols-3">
                    {DESTINATIONS.map((group, i) => (
                        <Reveal key={group.region} delay={0.1 * i}>
                            <div data-testid={`destination-region-${i}`}>
                                <div className="flex items-baseline gap-4">
                                    <span className="font-serif italic text-gold text-xl">{NUMERALS[i]}</span>
                                    <h3 className="font-serif text-xl sm:text-2xl">{group.region}</h3>
                                </div>
                                <div className="h-px w-12 bg-gold/60 my-5" />
                                <ul className="flex flex-wrap gap-x-2 gap-y-2.5">
                                    {group.places.map((place) => (
                                        <li key={place} className="flex items-center gap-2">
                                            <span className="font-light text-[15px] text-cream/85">{place}</span>
                                            <span className="h-1 w-1 rounded-full bg-gold/70" aria-hidden="true" />
                                        </li>
                                    ))}
                                </ul>
                                {group.note && (
                                    <p className="mt-4 font-serif italic text-sm text-gold/90">{group.note}</p>
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>

                <JourneyPath dark className="mt-16" />
                <Reveal delay={0.1}>
                    <p className="text-center font-serif italic text-2xl sm:text-3xl text-gold mt-6" data-testid="destinations-closing-line">
                        Your destination is only the beginning.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
